import { IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material";
import EditIcon from "src/assets/svg-icons/aggregators/edit.svg";
import DeleteIcon from "src/assets/svg-icons/aggregators/delete.svg";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { notificationsState } from "src/store/notifications";
import DownloadIcon from "src/assets/svg-icons/download.svg";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ConfirmPopup } from "src/shared/components/confirm-popup";
import { useDeletePurchaseMutation } from "src/api/purchasing/purchasing";
import { specificBranchHasPermission } from "src/utils";
import { PurchasingPermissions } from "src/constants/permissions";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";

interface IAction {
  row: any;
  refetch: Function;
}

const TableActions = (props: IAction) => {
  const { row, refetch } = props;
  const { id, reference } = row;
  const { t } = useTranslation("inventory");
  const { t: generalT } = useTranslation("general");
  const navigate = useNavigate();
  const [notifications, setNotifications] = useRecoilState(notificationsState);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openPay, setOpenPay] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openAttachmentsModal, setOpenAttachmentsModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [actionType, setActionType] = useState<string>();

  // APIS
  const { mutate, isPending, status, error } = useDeletePurchaseMutation();

  //permissions
  const editPermission = specificBranchHasPermission(
    PurchasingPermissions.editPurchasing,
    row.branch_id
  );
  const deletePermission = specificBranchHasPermission(
    PurchasingPermissions.deletePurchasing,
    row.branch_id
  );
  const payPermission = specificBranchHasPermission(
    PurchasingPermissions.payPurchasing,
    row.branch_id
  );

  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  const handleOpenPay = () => setOpenPay(true);
  const handleClosePay = () => setOpenPay(false);

  const handleOpenConfirm = (type: string) => {
    setActionType(type);
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => setOpenConfirm(false);

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigateToPoDetails = () => {
    navigate(`/inventory/reorder/po/${id}`);
  };

  const handleConfirm = () => {
    // mutate(id);
  };

  useEffect(() => {
    if (status === "success") {
      refetch();
      handleCloseConfirm();
      setNotifications([
        ...notifications,
        {
          type: "success",
          message: t("deletedSuccessfully"),
        },
      ]);
    } else if (status === "error") {
      setNotifications([
        ...notifications,
        {
          type: "error",
          message: error?.data.errors[0].value || t("somethingWrong"),
        },
      ]);
    }
  }, [status]);

  return (
    <Stack direction={"row"} spacing={"12px"} justifyContent={"center"}>
      <IconButton size="small" onClick={(e) => handleClick(e)}>
        <MoreVertIcon />
      </IconButton>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={(e) => handleOpenConfirm("sendEmail")}
          sx={{ gap: 1 }}
        >
          <img src={DownloadIcon} alt="" />
          <Typography
            color={"#1D2939"}
            fontSize={"16px"}
            textTransform={"capitalize"}
          >
            {t("sendEmail")}
          </Typography>
        </MenuItem>
        {true && (
          <MenuItem
            onClick={(e) => handleOpenConfirm("sendApp")}
            sx={{ gap: 1 }}
          >
            <img src={EditIcon} alt="" />
            <Typography
              color={"#1D2939"}
              fontSize={"16px"}
              textTransform={"capitalize"}
            >
              {t("sendApp")}
            </Typography>
          </MenuItem>
        )}

        {true && (
          <MenuItem
            sx={{ gap: 1 }}
            onClick={(e) => handleOpenConfirm("cancel")}
          >
            <img src={DeleteIcon} alt="" />
            <Typography
              color={"#1D2939"}
              fontSize={"16px"}
              textTransform={"capitalize"}
            >
              {t("cancel")}
            </Typography>
          </MenuItem>
        )}

        <MenuItem sx={{ gap: 1 }}>
          <VisibilityOutlinedIcon sx={{ fontSize: "16px" }} />
          <Typography
            color={"#1D2939"}
            fontSize={"16px"}
            textTransform={"capitalize"}
          >
            {t("shareWhatsApp")}
          </Typography>
        </MenuItem>

        <MenuItem onClick={navigateToPoDetails} sx={{ gap: 1 }}>
          <VisibilityOutlinedIcon sx={{ fontSize: "16px" }} />
          <Typography
            color={"#1D2939"}
            fontSize={"16px"}
            textTransform={"capitalize"}
          >
            {t("details")}
          </Typography>
        </MenuItem>

        {true ||
          (row?.status !== "Paid" && (
            <MenuItem onClick={handleOpenPay} sx={{ gap: 1 }}>
              <PaidOutlinedIcon sx={{ fontSize: "16px" }} />
              <Typography
                color={"#1D2939"}
                fontSize={"16px"}
                textTransform={"capitalize"}
              >
                {`${t("pay")}!`}
              </Typography>
            </MenuItem>
          ))}
      </Menu>

      {/* confirm delete popup */}
      <ConfirmPopup
        open={openConfirm}
        item={""}
        handleClose={handleCloseConfirm}
        handleConfirm={handleConfirm}
        isPending={isPending}
        title={
          actionType === "sendApp"
            ? t("sendApp")
            : actionType === "sendEmail"
            ? t("sendEmail")
            : actionType === "cancel"
            ? generalT("cancel")
            : t("cancel")
        }
        subtitle={generalT("areYouSureToConfirm")}
        confirmBtnText={generalT("confirm")}
        noIcon
      />
    </Stack>
  );
};
export default TableActions;
